import {AxiosProgressEvent} from 'axios';
import {PostRequestUploadFile} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRequestPostUploadFile} from 'data/usecases/private/authorizations';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {AuthorizationsFlowEndpoints} from '../../../endpoints';

export const makePostRequestUploadFile = (
	onUploadProgress?: (progressEvent: AxiosProgressEvent) => void,
): PostRequestUploadFile =>
	new RemoteRequestPostUploadFile(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.uploadFile),
		makeAuthorizeHttpClientDecorator(),
		onUploadProgress,
	);
